import React, {useEffect} from 'react'
import Navbar from '../components/Navbar/Navbar'
import ContactHero from '../components/Contact/Hero/ContactHero'
import ContactContent from '../components/Contact/ContactContent/ContactContent'
import Footer from '../components/Footer/Footer'

export default function Contact() {
    
    useEffect(()=>{
        const animOne = document.querySelectorAll('.anim-one');
        const animTwo = document.querySelectorAll('.anim-two');
        const animThree = document.querySelectorAll('.anim-three');
        
        let options = {
            threshold: 0.25
          }
      
        const observer = new IntersectionObserver((entries)=>{
          entries.forEach((entry)=>{
            if(entry.intersectionRatio > 0){
              if(entry.target.classList.contains('anim-one')){
                entry.target.style.animation = `animUp 0.5s ${entry.target.dataset.delay} forwards linear`;
              }else if(entry.target.classList.contains('anim-two')){
                entry.target.style.animation = `animDown 0.5s ${entry.target.dataset.delay} forwards linear`;
              }else if(entry.target.classList.contains('anim-three')){
                entry.target.style.animation = `animDownTwo 0.5s ${entry.target.dataset.delay} forwards linear`;
              }
            }
          })
        }, options)
    
        animOne.forEach(anim => {
          observer.observe(anim);
        })
        animTwo.forEach(anim => {
          observer.observe(anim);
        })
        animThree.forEach(anim => {
          observer.observe(anim);
        })
  },[]);

    return (
        <>
            <Navbar/>
            <ContactHero/>
            <ContactContent/>
            <Footer/>
        </>
    )
}
